import React, { Component, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import colors from "./Colors";
import Avatar from "@mui/material/Avatar";
import "./Styles/Dashboard.css";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import ListItemButton from "@mui/material/ListItemButton";
import Grocery from "./GroceryNew.js";
import Doctor from "./Doctor";
import Education from "./Education";
import MimBalance from "./MimBalance.tsx";
import WalletRecharge from "./WalletRecharge.tsx";


import FloodRelif from "./NFP";
import { useParams, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "./Containers/Table";
import NGO from "./NGO";
import NGOPKR from "./NGOPKR.js";

import NGOCAMPAIGN from "./NgoCampaign";
import HEALTH from "./Health.js";
import Sales from "./Sales";
import CEO from "./CEO";
import Approval from "./Containers/Approve";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import University from "./University";
import School from "./School";

// You can change this if you want to display specific countries only

const geoUrl =
  "https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json";

const Check = ({ name }) => {
  let navigate = useNavigate();
  // if(name === ""){
  //   navigate('/notfound');
  // }
  useEffect(() => {
    if (name === "") {
      navigate("/notfound");
    }
  }, []);
  return <div></div>;
};

const Signout = ({}) => {
  let navigate = useNavigate();
  const Logout = () => {
    sessionStorage.setItem("name", "");
    sessionStorage.setItem("level", "");
    sessionStorage.setItem("authkey", "");
    sessionStorage.setItem("id", "");
    navigate("/");
  };
  return (
    <div className="das-signout" onClick={Logout}>
      Signout
    </div>
  );
};

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: sessionStorage.getItem("name") || "",
      level: sessionStorage.getItem("level") || "",
      authkey: sessionStorage.getItem("authkey") || "",
      id: sessionStorage.getItem("id") || "",
      selectedIndex: 0,
      nameed: "",
      emailed: "",
      contacted: "",
      vve: "school",
      datastats: {
        isVer: 0,
        nonVer: 0,
        totalUsers: 0,
        totalMimBalance: 0,
        totalImpactCredits: 0,
        conversion_rate: 0,
        onetran: 0,
        country: [],
      },

      //data: this.props.location.state
    };
  }
  handleListItemClick = (event, index) => {
    this.setState({ selectedIndex: index });
  };
  settings = ["Profile", "Account", "Dashboard", "Logout"];
  stringAvatar(name) {
    return {
      sx: {
        bgcolor: colors["pinkish"],
      },
      children: `${name.split(" ")[0][0]}`, //${name.split(' ')[1][0]}``,
    };
  }

  menustyle = {
    color: "#ffffff",
    textAlign: "center",
    "&:hover": {
      background: colors.pinkish,
    },
    "&$selected": {
      color: "#d835633b",
      backgroundColor: colors.pinkish,
      border: colors.pinkish,
    },
  };

  logout = (event, index) => {
    sessionStorage.setItem("name", "");
    sessionStorage.setItem("level", "");
    sessionStorage.setItem("authkey", "");
    sessionStorage.setItem("id", "");
    this.setState({});
  };

  reg() {
    if (this.state.emailed === "") {
      alert("Please enter a valid email address");
      return;
    }
    if (this.state.nameed === "") {
      alert("Please enter a valid name");
      return;
    }
    if (this.state.contacted === "") {
      alert("Please enter a valid contact");
      return;
    }
    const postBody = {
      email: this.state.emailed,
      name: this.state.nameed,
      contact: this.state.contacted,
      module: this.state.vve,
    };

    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postBody),
    };
    fetch(
      "https://app.myimpactmeter.com/api/v2/dev/admin/school/createAdmin",
      requestMetadata
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          alert(result["message"]);
          if (result["success"]) {
            navigator.clipboard.writeText(result["data"]["password"]);
            alert(
              "One time Password is " +
                result["data"]["password"] +
                " is Copied to clipboard."
            );
            var collection = document.getElementsByClassName("prompteducre");
            collection[0].style.display = "none";
            this.setState({ emailed: "" });
            this.setState({ nameed: "" });
            this.setState({ contacted: "" });
          }
        },
        (error) => {
          alert(error.message);
        }
      );
  }

  onChangevalueEmail = (e) => {
    this.setState({ emailed: e.target.value });
  };
  onChangevalueName = (e) => {
    this.setState({ nameed: e.target.value });
  };
  onChangevalueContact = (e) => {
    this.setState({ contacted: e.target.value });
  };

  onChangevalueRV = (e) => {
    console.log(e.target.value);
    this.setState({ vve: e.target.value });
  };

  onCLose = (e) => {
    var collection = document.getElementsByClassName("prompteducre");
    collection[0].style.display = "none";
  };

  onOpen = (e) => {
    var collection = document.getElementsByClassName("prompteducre");
    collection[0].style.display = "block";
  };

  componentDidMount() {
    var addrr = "http://sfoadmin.myimpactmeter.com:5050";
    fetch(addrr + "/admin/stats")
      .then((response) => response.json())
      .then((data) => this.setState({ datastats: data["data"] }));
  }

  onJaaz = (e) => {
    let message = prompt("Jaaz TiD to check");

    if (message === null) {
      return;
    }
    const postBody = {
      pp_TxnRefNo: message,
      pp_MerchantID: "MC58667",
      pp_Password: "t5xu1g0tgs",
      pp_SecureHash:
        "54be03004932844c10741bbbd77b7cfcd8ae8f3aadfa2638216afdfdc2b5a9f9",
    };

    // Combine username and password, then base64 encode
    const username = "rizwan@myimpactmeter.com";
    const password =
      "9dbb13e0fce48f9dffe9d2218428220512b123dc4006f79c019505eec7b03e56";
    const base64Credentials = btoa(username + ":" + password);

    const requestMetadata = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + base64Credentials,
      },
      // body: JSON.stringify(postBody),
    };

    fetch(
      "https://app.myimpactmeter.com/api/v2/dev/ipg/jazzcash/status?id=" +
        message, // Replace with your actual API URL
      requestMetadata
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          alert(
            result["data"]["resposne"]["pp_PaymentResponseMessage"] +
              " - " +
              result["data"]["resposne"]["pp_Status"]
          );
        },
        (error) => {
          alert(error.message);
        }
      );
  };

  onJaazRefund = (e) => {
    let message = prompt("Jaaz TiD to Refund");

    if (message === null) {
      return;
    }
    const postBody = {
      MPIN: "1234",
      txAmount: "100",
      TID: message,
    };

    // Combine username and password, then base64 encode
    const username = "rizwan@myimpactmeter.com";
    const password =
      "9dbb13e0fce48f9dffe9d2218428220512b123dc4006f79c019505eec7b03e56";
    const base64Credentials = btoa(username + ":" + password);

    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + base64Credentials,
      },
      body: JSON.stringify(postBody),
    };

    fetch(
      "https://app.myimpactmeter.com/api/v2/dev/ipg/jazzcash/refund", // Replace with your actual API URL
      requestMetadata
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result["data"]);
          alert(
            result["data"]["resposne"]["pp_ResponseMessage"] +
              " - " +
              "Refunded"
          );
        },
        (error) => {
          alert(error.message);
        }
      );
  };

  render() {
    return (
      <div className="das-main">
        <Check name={this.state.name} />
        <div className="flexnav">
          <ListItemButton
            selected={this.state.selectedIndex === 1}
            onClick={(event) => this.handleListItemClick(event, 0).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="Dashboard " />
          </ListItemButton>
          {this.state.level === "10" ? (
            <ListItemButton
              selected={this.state.selectedIndex === 10}
              onClick={(event) =>
                this.handleListItemClick(event, 10).bind(this)
              }
              sx={this.menustyle}
            >
              <ListItemText className="das-name2" primary="CEO" />
            </ListItemButton>
          ) : (
            <div></div>
          )}
          <ListItemButton
            selected={this.state.selectedIndex === 1}
            onClick={(event) => this.handleListItemClick(event, 1).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="Grocery" />
          </ListItemButton>
          {/* <ListItemButton
            selected={this.state.selectedIndex === 2}
            onClick={(event) => this.handleListItemClick(event, 2).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText primary="Doctor" />
          </ListItemButton> */}
          <ListItemButton
            selected={this.state.selectedIndex === 3}
            onClick={(event) => this.handleListItemClick(event, 3).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="Education" />
          </ListItemButton>
          <ListItemButton
            selected={this.state.selectedIndex === 4}
            onClick={(event) => this.handleListItemClick(event, 4).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="NGO (PKR)" />
          </ListItemButton>
          <ListItemButton
            selected={this.state.selectedIndex === 12}
            onClick={(event) => this.handleListItemClick(event, 12).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="NGO (USD)" />
          </ListItemButton>
          <ListItemButton
            selected={this.state.selectedIndex === 13}
            onClick={(event) => this.handleListItemClick(event, 13).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="SCHOOL" />
          </ListItemButton>
          <ListItemButton
            selected={this.state.selectedIndex === 7}
            onClick={(event) => this.handleListItemClick(event, 7).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="NGOCAMPAIGN" />
          </ListItemButton>

          <ListItemButton
            selected={this.state.selectedIndex === 14}
            onClick={(event) => this.handleListItemClick(event, 14)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="HEALTH" />
          </ListItemButton>

          <ListItemButton
            selected={this.state.selectedIndex === 5}
            onClick={(event) => this.handleListItemClick(event, 5).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText
              className="das-name2"
              primary="Special(Flood / Impactech)"
            />
          </ListItemButton>

          <ListItemButton
            selected={this.state.selectedIndex === 6}
            onClick={(event) => this.handleListItemClick(event, 6).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="Sales" />
          </ListItemButton>

          <ListItemButton
            selected={this.state.selectedIndex === 7}
            onClick={(event) => this.handleListItemClick(event, 11).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="Univerity" />
          </ListItemButton>
          <ListItemButton
            selected={this.state.selectedIndex === 8}
            onClick={(event) => this.handleListItemClick(event, 8).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="MIM Balance" />
          </ListItemButton>
             <ListItemButton
            selected={this.state.selectedIndex === 6}
            onClick={(event) => this.handleListItemClick(event, 6).bind(this)}
            sx={this.menustyle}
          >
            <ListItemText className="das-name2" primary="Wallet Recharge" />
          </ListItemButton>
        </div>

        <div
          className="das-disable"
          onClick={() => {
            var mainbottom = document.getElementsByClassName("das-nav-menu");
            mainbottom[0].style.display = "none";
            mainbottom = document.getElementsByClassName("das-disable");
            mainbottom[0].style.display = "none";
          }}
        ></div>

        {this.state.selectedIndex === 0 ? (
          <Box
            sx={{
              width: "97%",
              height: "90%",
              backgroundColor: colors["white"],
            }}
            className="das-body"
          >
            <p className="das-name">Hi {this.state.name},</p>

            {this.state.level === "5" ? (
              <div className="allcontents">
                <div className="edubutt" onClick={this.onOpen.bind(this)}>
                  Make Education Account
                </div>
                <br></br>
                <div onClick={this.onJaaz.bind(this)} className="edubutt">
                  Jaaz Cash
                </div>
                <br></br>
                <div onClick={this.onJaazRefund.bind(this)} className="edubutt">
                  Jaaz Cash Refund
                </div>
                <br></br>
                <div
                  className="edubutt"
                  onClick={() => {
                    var collection = document.getElementsByClassName("approve");
                    collection[0].style.display = "block";
                  }}
                >
                  Approval Ngo
                </div>
                <br></br>
                <div
                  className="edubutt"
                  onClick={() => {
                    var collection = document.getElementsByClassName("approve");
                    collection[1].style.display = "block";
                  }}
                >
                  Approval Edu
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <Approval list={this.state.uango} module="NGO" />
            <Approval list={this.state.uaedu} module="EDU" />

            <Signout />
            <div className="prompteducre">
              <p className="register">Register Institution </p>
              <p className="close" onClick={this.onCLose.bind(this)}>
                +
              </p>
              <input
                className="inputemq"
                value={this.state.emailed}
                onChange={this.onChangevalueEmail.bind(this)}
                type="email"
                placeholder="Email"
              ></input>
              <input
                className="inputemq"
                value={this.state.nameed}
                onChange={this.onChangevalueName.bind(this)}
                type="name"
                placeholder="Name"
              ></input>
              <input
                className="inputemq"
                value={this.state.contacted}
                onChange={this.onChangevalueContact.bind(this)}
                type="contact"
                placeholder="Contact"
              ></input>
              <select
                className="inputemq"
                value={this.state.vve}
                id="inputemq"
                onChange={this.onChangevalueRV.bind(this)}
              >
                <option value="vocational">Vocational</option>
                <option value="school">School</option>
              </select>
              <p>&nbsp;</p>

              <Button
                variant="contained"
                color="success"
                className="b1"
                onClick={this.reg.bind(this)}
              >
                Register
              </Button>
            </div>
            <div className="stats">
              <Box
                sx={{
                  backgroundColor: colors["cream"],
                  borderRadius: "20px",
                  borderColor: "black",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                className="das-gro-count"
              >
                <p className="das-gro-count-c">
                  {this.state.datastats["isVer"]}
                </p>
                <p className="das-gro-count-t">Users Verified</p>
              </Box>
              <br></br>
              <Box
                sx={{
                  backgroundColor: colors["cream"],

                  borderRadius: "20px",
                  borderColor: "black",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                className="das-gro-sales"
              >
                <p className="das-gro-count-c">
                  {this.state.datastats["nonVer"]}
                </p>
                <p className="das-gro-count-t">Non Verified Users</p>
              </Box>
              <br></br>
              <Box
                sx={{
                  backgroundColor: colors["cream"],

                  borderRadius: "20px",
                  borderColor: "black",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                className="das-gro-co-req"
              >
                <p className="das-gro-count-c">
                  {this.state.datastats["totalUsers"]}
                </p>
                <p className="das-gro-count-t">Total User</p>
              </Box>
              <br></br>
              <Box
                sx={{
                  backgroundColor: colors["cream"],

                  borderRadius: "20px",
                  borderColor: "black",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                className="das-gro-co-req-2"
              >
                <p className="das-gro-count-c">
                  {this.state.datastats["totalMimBalance"]}
                </p>
                <p className="das-gro-count-t">Total User MIM Balance</p>
              </Box>
              <br></br>
              <Box
                sx={{
                  backgroundColor: colors["cream"],

                  borderRadius: "20px",
                  borderColor: "black",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                className="das-gro-co-req-3"
              >
                <p className="das-gro-count-c">
                  {this.state.datastats["totalImpactCredits"]}
                </p>
                <p className="das-gro-count-t">Total User Impact Credits</p>
              </Box>
              <Box
                sx={{
                  backgroundColor: colors["cream"],

                  borderRadius: "20px",
                  borderColor: "black",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                className="das-gro-co-req-3"
              >
                <p className="das-gro-count-c">
                  {this.state.datastats["conversion_rate"]} %
                </p>
                <p className="das-gro-count-t">Conversion Rate</p>
              </Box>
            </div>

            <div className="mapp">
              <ComposableMap style={{ width: "50%" }}>
                <Geographies geography={geoUrl}>
                  {({ geographies }) =>
                    geographies.map((geo) =>
                      this.state.datastats["country"].includes(
                        geo.properties.name
                      ) ? (
                        <Geography
                          key={geo.rsmKey}
                          geography={geo}
                          fill="#F53"
                        />
                      ) : (
                        <Geography
                          key={geo.rsmKey}
                          geography={geo}
                          fill="#EAEAEC"
                        />
                      )
                    )
                  }
                </Geographies>
              </ComposableMap>
            </div>

            {/* <Table data={data}/> */}
          </Box>
        ) : this.state.selectedIndex === 1 ? (
          <Grocery />
        ) : this.state.selectedIndex === 2 ? (
          <Doctor />
        ) : this.state.selectedIndex === 3 ? (
          <Education />
        ) : this.state.selectedIndex === 4 ? (
          <NGOPKR curancy="PKR" />
        ) : this.state.selectedIndex === 12 ? (
          <NGO curancy="USD" />
        ) : this.state.selectedIndex === 7 ? (
          <NGOCAMPAIGN />
        ) : this.state.selectedIndex === 14 ? (
          <HEALTH />
        ) : this.state.selectedIndex === 5 ? (
          <FloodRelif />
        ) : this.state.selectedIndex === 10 ? (
          <CEO />
        ) : this.state.selectedIndex === 11 ? (
          <University />
        ) : this.state.selectedIndex === 13 ? (
          <School />
        ) : this.state.selectedIndex === 8 ? (
          <>
            <MimBalance />
          </>
        ) : this.state.selectedIndex === 6 ? (
          <>
                      <WalletRecharge />

          </>
        ):(
          <Sales />
        )}
      </div>
    );
  }
}

export default Dashboard;
